import { useEffect, useState } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"
import axios from "axios"
import "../styles/auth.css"

const API = process.env.REACT_APP_API_URL || "http://localhost:8000"

export default function VerifyEmail() {
    const [params] = useSearchParams()
    const nav = useNavigate()
    const [status, setStatus] = useState("verifying")  // verifying | success | error

    useEffect(() => {
        const token = params.get("token")
        if (!token) {
            setStatus("error")
            return
        }
        axios.get(`${API}/verify?token=${token}`)
            .then(() => {
                setStatus("success")
                setTimeout(() => nav("/login"), 3000)
            })
            .catch(() => setStatus("error"))
    }, [params, nav])

    return (
        <div className="auth-page">
            <div className="auth-card" style={{ textAlign: "center" }}>
                <div className="auth-logo">ArbSignal</div>
                {status === "verifying" && (
                    <>
                        <h2 className="auth-title">Verifying your email...</h2>
                        <p className="auth-sub">Just a moment.</p>
                    </>
                )}
                {status === "success" && (
                    <>
                        <h2 className="auth-title" style={{ color: "#00ffc6" }}>Email verified!</h2>
                        <p className="auth-sub">Redirecting to login in 3 seconds...</p>
                    </>
                )}
                {status === "error" && (
                    <>
                        <h2 className="auth-title" style={{ color: "#f87171" }}>Verification failed</h2>
                        <p className="auth-sub">The link may be expired or invalid.</p>
                        <button
                            className="auth-submit"
                            onClick={() => nav("/login")}
                            style={{ marginTop: 24 }}
                        >
                            Go to login
                        </button>
                    </>
                )}
            </div>
        </div>
    )
}
